import Button from 'components/generic-components/thera-start-components/Button';
import { GoArrowLeft } from 'react-icons/go';
import { FaCheck } from 'react-icons/fa6';

export default function WorryFreeComplianceStep({ formik, onNext, onBack }) {
  return (
    <div className="flex flex-col items-center justify-center bg-[#181818] px-4 py-8">
      {/* Back button OUTSIDE the card */}
      <div className="mb-4 w-full">
        <button
          type="button"
          onClick={onBack}
          className="mb-2 flex items-center gap-2 font-semibold text-white transition-colors hover:text-blue-500"
        >
          <GoArrowLeft size={18} />
          <span>Back</span>
        </button>
      </div>

      {/* Card */}
      <div className="flex min-h-[32rem] w-full flex-col justify-between rounded-2xl bg-white p-6 shadow-xl sm:p-8 md:p-10">
        <div>
          <p className="mb-2 text-[1.59rem] font-semibold text-dark">Ongoing Worry-Free Compliance Service</p>
          <p className="mb-4 text-[#0000007A]">
            Get alerts for state compliance events and let our team handle your annual report and amendment filings.
          </p>

          <div className="mb-2 flex items-center justify-between">
            <span className="font-semibold text-dark">Worry-Free Compliance</span>
            <span className="font-bold text-therablue">1 Year Free</span>
          </div>
          <div className="mb-2 text-dark">Renews at $250/yr.</div>
          <hr className="mb-4" />

          <div className="mb-4">
            <div className="mb-2 font-bold text-dark">WHAT TO KNOW</div>
            <ul className="mb-4 space-y-2 text-[#191919CC]">
              <li className="mb-[1rem] flex items-center font-sans text-[0.875rem] text-light-gray sm:text-[1rem]">
                <span className="mr-[1rem] flex size-5 shrink-0 items-center justify-center rounded-full bg-[#F2F2F2] pb-[0.25rem]">
                  <FaCheck className="mt-1 size-3 text-dark" />
                </span>{' '}
                <span className="text-dark-gray">
                  We file your state-required annual report and up to 2 yearly amendments — you just cover the state
                  fees.
                </span>
              </li>
              {/* <li className="flex items-center text-light-gray text-[0.875rem] sm:text-[1rem] font-sans mb-[1rem]"><span className="size-5 mr-[1rem] bg-[#F2F2F2] rounded-full flex items-center justify-center pb-[0.25rem]">
                <FaCheck className="mt-1 size-3 text-dark" />
              </span> <span className="text-dark-gray">Easily view key due dates in the compliance calendar.</span></li> */}
              <li className="mb-[1rem] flex items-center font-sans text-[0.875rem] text-light-gray sm:text-[1rem]">
                <span className="mr-[1rem] flex size-5 items-center justify-center rounded-full bg-[#F2F2F2] pb-[0.25rem]">
                  <FaCheck className="mt-1 size-3 text-dark" />
                </span>{' '}
                <span className="text-dark-gray">Miss a deadline? We'll help you get back into compliance.</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-6 flex flex-col gap-3">
          <Button
            className="w-full rounded-lg !bg-black py-3 text-[1rem] font-semibold !text-white transition-colors hover:!bg-gray-900"
            onClick={() => {
              formik.setFieldValue('worryFreeCompliance', true);
              onNext();
            }}
          >
            Yes, keep me covered
          </Button>

          <Button
            variant="white"
            className="w-full rounded-lg border border-black bg-white py-3 text-[1rem] font-semibold text-black transition-colors hover:bg-gray-100"
            onClick={() => {
              formik.setFieldValue('worryFreeCompliance', false);
              onNext();
            }}
          >
            Skip
          </Button>
        </div>
      </div>
    </div>
  );
}
